// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fc-custom-list {
  border: #ddd 1px solid;
  height: calc(100% - 60px);
}
.fc-custom-list .fc-list-view {
  border: 0;
  height: calc(100% - 60px) !important;
}
.fc-custom-list .fc-custom-list-container .custom-list-body {
  padding: 10px;
}
.fc-custom-list .fc-custom-list-container h1.fc-custom-dateheading {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  margin: 0;
}
.fc-custom-list .fc-custom-list-container .fc-custom-list-item {
  margin: 10px 0;
  display: block;
  border-radius: 5px;
  padding: 3px 10px;
  cursor: pointer;
  border-left: 5px solid transparent;
  background-color: rgba(212, 212, 212, 0.7);
}

.rightPanelList {
  height: 100%;
}

.dash-scheduler-title {
  font-size: 24px;
  margin: 5px 0 15px 10px;
  width: 150px;
}

.fc-custom-list .fc-custom-list-container .fc-custom-list-item.meeting-info {
  display: flex;
}

.meeting-info {
  flex-direction: row;
}
@media (max-width: 768px) {
  .meeting-info {
    flex-direction: column;
  }
  .meeting-info .meeting-badge-list, .meeting-info .meeting-box-container-list {
    display: flex;
    flex-wrap: wrap;
  }
}
.meeting-info .meeting-badge-list {
  height: 100%;
  align-self: flex-end;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 2px;
}
.meeting-info .meeting-badge-list > forge-badge:first-child {
  margin-left: 0px;
}
.meeting-info .meeting-badge-list > forge-badge {
  margin-left: 4px;
  margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/common/schedular-list-view/schedular-list-view.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,yBAAA;AACJ;AAAI;EACI,SAAA;EAAS,oCAAA;AAGjB;AAAQ;EACI,aAAA;AAEZ;AAAQ;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AAEZ;AAAQ;EACI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;EACA,0CAAA;AAEZ;;AAEA;EACI,YAAA;AACJ;;AAEA;EAAsB,eAAA;EAAgB,uBAAA;EAAwB,YAAA;AAI9D;;AAFA;EAGI,aAAA;AAGJ;;AAAA;EACI,mBAAA;AAGJ;AAFI;EAFJ;IAGQ,sBAAA;EAKN;EAHM;IACI,aAAA;IACA,eAAA;EAKV;AACF;AAFI;EACI,YAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AAIR;AAFQ;EACI,gBAAA;AAIZ;AADQ;EACI,gBAAA;EACA,kBAAA;AAGZ","sourcesContent":[".fc-custom-list {\r\n    border: #ddd 1px solid;\r\n    height:calc(100% - 60px);\r\n    .fc-list-view{\r\n        border:0;height:calc(100% - 60px) !important;\r\n    }\r\n    .fc-custom-list-container{\r\n        .custom-list-body{\r\n            padding: 10px;\r\n        }\r\n        h1.fc-custom-dateheading{\r\n            font-size: 14px;\r\n            color:rgba(0,0,0,0.6);\r\n            font-weight: 500;\r\n            margin: 0;\r\n        }\r\n        .fc-custom-list-item{\r\n            margin: 10px 0;\r\n            display: block;\r\n            border-radius: 5px;\r\n            padding: 3px 10px;\r\n            cursor: pointer;\r\n            border-left: 5px solid transparent;\r\n            background-color: rgba(212,212,212,0.7);\r\n        }\r\n    }\r\n}\r\n.rightPanelList{\r\n    height: 100%; \r\n}\r\n\r\n.dash-scheduler-title{font-size: 24px;margin: 5px 0 15px 10px;width: 150px;}\r\n\r\n.fc-custom-list\r\n.fc-custom-list-container\r\n.fc-custom-list-item.meeting-info {\r\n    display: flex;\r\n}\r\n\r\n.meeting-info {\r\n    flex-direction: row;\r\n    @media (max-width: 768px) {\r\n        flex-direction: column;\r\n\r\n        .meeting-badge-list, .meeting-box-container-list {\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n        }\r\n    }\r\n\r\n    .meeting-badge-list {\r\n        height: 100%;\r\n        align-self: flex-end;\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        align-items: flex-end;\r\n        padding: 2px;\r\n    \r\n        > forge-badge:first-child {\r\n            margin-left: 0px;\r\n        }\r\n    \r\n        > forge-badge {\r\n            margin-left: 4px;\r\n            margin-bottom: 4px;\r\n        }\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
